import { ProvidersView, useToast } from '@elva/ui';
import { useWorkspaceLabel } from '@elva/platform';
import { useMemo } from 'react';
import { ElvaSectionState } from '@/components/ElvaSectionState';
import { adaptPracticeProviders, practiceProviderToApi } from '../adapters/settingsAdapters';
import { useProviders } from '../hooks/useProviders';
import { useUpdateProvider } from '../hooks/useUpdateProvider';

/** Practice management › Providers (spec 15 §5). Roster + the drawer, on the providers API. */
export function SettingsProvidersPage() {
  const workspaceLabel = useWorkspaceLabel();
  const { data, isLoading, isError } = useProviders(true);
  const updateProvider = useUpdateProvider();
  const { toast } = useToast();

  const providers = useMemo(() => adaptPracticeProviders(data?.providers ?? []), [data?.providers]);

  return (
    <ElvaSectionState isLoading={isLoading} isError={isError}>
      <ProvidersView
        providers={providers}
        location={workspaceLabel}
        lastSync="—"
        onSaveProvider={async (next) => {
          const original = data?.providers.find((p) => p.id === next.id);
          if (!original) return;
          try {
            await updateProvider.mutateAsync({ id: next.id, data: practiceProviderToApi(next, original) });
          } catch (err) {
            toast({ title: 'Could not save provider', variant: 'error' });
            throw err;
          }
        }}
      />
    </ElvaSectionState>
  );
}
